/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    searchUser(params) {
        return HttpService.get(environment.API_USER_SEARCH, {
            params,
        });
    },
    getRoleUser() {
        return HttpService.get(environment.API_ROLES_USER);
    },
    getPermissionUser() {
        return HttpService.get(environment.API_PERMISSION_USER);
    },
    getUserDetail(payload) {
        return HttpService.get(environment.API_GET_USER_DETAIL + payload);
    },
    saveUserDetail(payload) {
        return HttpService.post(environment.API_SAVE_USER_DETAIL, payload);
    },
    editUserDetail(payload) {
        return HttpService.put(environment.API_SAVE_USER_DETAIL, payload);
    },
    changeUserStatus(status, userId) {
        let payload = {
            userId: userId,
            userStatus: status,
        };
        return HttpService.put(environment.API_CHANGE_STATUS, payload);
    },

    ////////////
    searchUserDepartment(params) {
        return HttpService.get(environment.API_DEPARTMENT_SEARCH, {
            params,
        });
    },

    saveDepartmentDetail(payload) {
        return HttpService.post(environment.API_SAVE_DEPARTMENT, payload);
    },

    editDepartmentDetail(payload) {
        return HttpService.put(environment.API_SAVE_DEPARTMENT, payload);
    },

    getDepartmentDetail(payload) {
        return HttpService.get(environment.API_GET_DEPARTMENT_DETAIL + payload);
    },
    deleteDepartment(departmentId) {
        return HttpService.delete(
            environment.API_DELETE_DEPARTMENT + departmentId
        );
    },
    changePassword(payload) {
        return HttpService.post(environment.API_CHANGE_PASSWORD, payload);
    },

    //Resend Email
    ResendEmail(payload) {
        return HttpService.post(environment.API_FORGOT_PASSWORD, payload);
    },

    RevokeInvite(userId) {
        return HttpService.delete(environment.API_WFSECURE + `/user/${userId}`);
    },

    getEmailSettings(params) {
        return HttpService.get(environment.API_EMAIL_SETTING, {
            params,
        });
    },

    getEmailDeatils(id) {
        return HttpService.get(environment.API_EMAIL_SETTING + `/${id}`);
    },

    updateEmailSetting(payload) {
        return HttpService.put(environment.API_EMAIL_SETTING, payload);
    },

    submitSuggestion(payload) {
        return HttpService.post(environment.API_COMMENT_DISK_SPACE, payload);
    },
};
